"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Events = void 0;
var Events;
(function (Events) {
    Events["SEND_TYPEAHEAD_TERMS"] = "@event/SEND_TYPEAHEAD_TERMS";
    Events["OPEN_TYPEAHEAD"] = "@event/OPEN_TYPEAHEAD";
    Events["CLOSE_TYPEAHEAD"] = "@event/CLOSE_TYPEAHEAD";
    Events["SUBMIT_FORM"] = "@event/SUBMIT_FORM";
    Events["INITIALIZE_STATE"] = "@event/INITIALIZE_STATE";
    Events["SEND_LOCATION"] = "@event/SEND_LOCATION";
    Events["PREVIEW_SHOW_ERROR"] = "@event/PREVIEW_SHOW_ERROR";
    Events["PREVIEW_HIDE_ERROR"] = "@event/PREVIEW_HIDE_ERROR";
    Events["DONE_FETCH_CONFIG"] = "done.invoke.@service/FETCH_CONFIG";
    Events["DONE_FETCH_TYPEAHEAD"] = "done.invoke.@service/FETCH_TYPEAHEAD_SUGGESTIONS";
    Events["DONE_INITIALIZE_LOGGING"] = "done.invoke.@service/INITIALIZE_LOGGING";
    Events["DONE_FILL_IN_CONFIG_DEFAULTS"] = "done.invoke.@service/FILL_IN_CONFIG_DEFAULTS";
})(Events = exports.Events || (exports.Events = {}));
//# sourceMappingURL=events.js.map